'use client';

import React, { useMemo } from 'react';
import {
  Input,
  ProgressBar,
  Separator,
  Switch,
} from '@yaradigitallabs/ahua-react';
import { useAppSelector } from '@/app/hooks';
import { selectMaterialDetailData } from '../../store/material-detail.selectors';
import { useProductionAndConsumptionFilterContext } from '../context';

type FiltersProps = {
  isLoading: boolean;
};
const Filters: React.FC<FiltersProps> = ({ isLoading }) => {
  const materialDetail = useAppSelector(selectMaterialDetailData);
  const { setTextFilter, textFilter, setUnmatchedOnly, unmatchedOnly } =
    useProductionAndConsumptionFilterContext();
  const [completed, total] = useMemo(() => {
    if (materialDetail) {
      const total =
        1 +
        ((materialDetail.components || []).length || 0) +
        ((materialDetail.routings || []).length || 0);
      let completed = 0;
      if (materialDetail.tags && materialDetail.tags.length > 0) {
        completed += 1;
      }
      if (materialDetail.components) {
        completed += materialDetail.components.filter(
          component => component.tags && component.tags.length > 0
        ).length;
      }
      if (materialDetail.routings) {
        completed += materialDetail.routings.filter(
          routing => routing.tags && routing.tags.length > 0
        ).length;
      }
      return [completed, total];
    } else {
      return [0, 0];
    }
  }, [materialDetail]);

  const startLabel = useMemo(() => {
    if (isLoading) {
      return 'Loading...';
    } else if (completed === 0) {
      return 'No items are matched';
    } else {
      return '';
    }
  }, [isLoading, completed]);

  return (
    <div className="">
      <form className="grid grid-cols-1 md:grid-cols-3 gap-4 px-6 py-4">
        <Input
          label="Search"
          size="s"
          iconLeading="Search"
          value={textFilter}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setTextFilter(e.target.value)
          }
        />
        <div className="flex justify-start items-center space-x-2 font-black">
          <Switch
            label="View only unmatched items"
            labelPosition="right"
            checked={unmatchedOnly}
            onCheckedChange={setUnmatchedOnly}
            style={{ fontWeight: 600 }}
          />
        </div>
        <ProgressBar
          numberOfSteps={total}
          completedSteps={completed}
          className="w-full"
          startLabel={startLabel}
          labels={
            Array.from(
              { length: total },
              (_, index) =>
                `${index + 1} out of ${total} items are already matched`
            ) || []
          }
        />
      </form>
      <Separator />
    </div>
  );
};

export default Filters;
